import { processingFeeDollars } from "./processingFee.js";
import { turnstile } from "./turnstile.js";

export function support(chargebeeSite = null, defaultContribution = 100, processingFeeRate = 0) {

  let chargebeePromise = null;

  return {
    ...turnstile("support-contribution"),

    init() {
      this.initTurnstile();
    },

    name: "",
    email: "",
    preset: defaultContribution,
    custom: "",
    subscribe: false,

    submitting: false,
    errorMessage: "",

    get contribution() {
      if (this.preset !== null) {
        return this.preset;
      }
      const parsed = parseFloat(this.custom.replace(/[^0-9.]/g, ""));
      return isNaN(parsed) || parsed < 0 ? 0 : parsed;
    },

    get subtotalCents() {
      return Math.round(this.contribution * 100);
    },

    get processingFee() {
      return processingFeeDollars(this.subtotalCents, processingFeeRate);
    },

    get total() {
      return this.contribution + this.processingFee;
    },

    money(value) {
      return `$${value.toFixed(2)}`;
    },

    createHostedPage() {
      return fetch(this.$refs.form.action, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new URLSearchParams(new FormData(this.$refs.form)),
      })
        .then((response) =>
          response.json().catch(() => ({})).then((body) => {
            if (!response.ok) {
              throw new Error(body.message || "Something went wrong. Please try again.");
            }
            return body;
          }),
        )
        .catch((err) => {
          this.errorMessage = err.message || "Something went wrong. Please try again.";
          this.submitting = false;
          this.resetTurnstile();
          throw err;
        });
    },

    loadChargebee() {
      if (chargebeePromise) {
        return chargebeePromise;
      }

      chargebeePromise = new Promise((resolve, reject) => {
        if (window.Chargebee) {
          resolve(window.Chargebee);
          return;
        }

        const script = document.createElement("script");
        script.src = "https://js.chargebee.com/v2/chargebee.js";
        script.async = true;
        script.onload = () => resolve(window.Chargebee);
        script.onerror = () => reject(new Error("Could not load the payment form."));
        document.head.appendChild(script);
      }).then((Chargebee) => {
        try {
          return Chargebee.getInstance();
        } catch {
          return Chargebee.init({ site: chargebeeSite });
        }
      });

      chargebeePromise.catch(() => {
        chargebeePromise = null;
      });

      return chargebeePromise;
    },

    async openCheckout() {
      if (this.submitting) {
        return;
      }

      this.errorMessage = "";
      this.submitting = true;

      let chargebee;

      try {
        chargebee = await this.loadChargebee();
      } catch (err) {
        this.errorMessage = err.message || "Something went wrong. Please try again.";
        this.submitting = false;
        return;
      }

      let successUrl;

      chargebee.openCheckout({
        loaded: () => {
          this.$dispatch("checkout-opened", { checkoutType: "contribution" });
        },
        hostedPage: () =>
          this.createHostedPage().then((body) => {
            successUrl = body.successUrl;
            return body.hostedPage;
          }),
        success: () => {
          window.location.replace(successUrl);
        },
        close: () => {
          this.submitting = false;
          this.resetTurnstile();
        },
      });
    },
  };
}
